var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "mb-2 col-md-6 d-flex align-items-center" },
        [
          _c(
            "el-checkbox",
            {
              attrs: { value: _vm.pendingAsBoolean },
              on: { input: _vm.onChange },
            },
            [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n    ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }